<!--新闻状态-->
<template>
  <div class="news-state">
    <!--公司动态-->
    <div class="news-box">
      <div class="content">
        <!-- pc端标题 -->
        <div class="title" v-show="!this.$store.state.isMobile">
          <span>What's News</span> at Kids ‘R’ Kids?
        </div>
        <!-- 移动端标题 -->
        <div class="content-mobile" v-show="this.$store.state.isMobile">
          <div class="title">What's New</div>
          <div class="smallTitle-right">at Kids ‘R’ Kids ?</div>
        </div>
        <div class="smallTitle">
          <span>公司动态</span>
        </div>
        <news :news="news"></news>
        <!--分页 -->
        <!-- <v-pagination :pagingparam="pagingparam" @pageData="pageData"></v-pagination> -->
      </div>
    </div>
    <!--园所动态-->
    <div class="news-box news-box2">
      <div class="content">
        <div class="smallTitle">
          <span>园所动态</span>
        </div>
        <news :news="newsData1"></news>
        <!--分页 -->
        <!-- <v-pagination :pagingparam="pagingparam" @pageDataGarden="pageData"></v-pagination> -->
      </div>
    </div>
    <div class="bg2">
      <img src="https://krk-website.oss-cn-beijing.aliyuncs.com/img/news_bg2.jpg" alt="">
      <div class="bg2-con">
        <p class="p1">INTERNATIONAL VISION</p>
        <p class="p2">培养具有国际视野的中国孩子</p>
      </div>
    </div>
  </div>
</template>

<script>
import news from "@/components/news/news"; //新闻
import pagination from "@/components/pagination/pagination"; //分页
import newsData from "../../../static/mock/news.json";

export default {
  data() {
    return {
      tab: this.$route.query.id,
      news: [],
      newsData1: []
      //  pagingparam:{    //分页参数
      //   url:'getNews',  //接口
      //   params:{
      //     pageSize:3, //每页条数
      //     pageNo:1  //当前页数
      //   },
      //   total:13//总的条数
      // },
    };
  },
  mounted() {
    this.$nextTick(() => {
      this.getNews(); //获取新闻
      this.getGardenNews(); //获取园所新闻
    });
  },
  components: {
    news,
    "v-pagination": pagination
  },
  methods: {
    getNews() {
      //获取新闻
      this.$post("/newsMaintain/list", {
        pageNo: 1,
        pageSize: 10,
        newsType: 1 //1，公司动态；2，园所动态',
      })
        .then(res => {
          if (res.code === "00") {
            this.news = res.data.list.slice(0, 3);
          }
        })
        .catch(() => {});
      // this.news = newsData.data.list.slice(0,3);
    },
    getGardenNews() {
      //获取园所新闻
      this.$post("/newsMaintain/list", {
        pageNo: 1,
        pageSize: 10,
        newsType: 2
      })
        .then(res => {
          if (res.code === "00") {
            this.newsData1 = res.data.list.slice(0, 3);
          }
        })
        .catch(() => {});
      // this.newsData1 = newsData.data.list.slice(-3);
    },
    pageData: function(data) {
      //获取分页数据
      console.log(data);
      this.newsData = data.list;
    },
    pageDataGarden: function(data) {
      //获取分页数据
      console.log(data);
      this.newsData1 = data.list;
    }
  }
};
</script>
<style rel="stylesheet/scss" lang="scss">
@import "@/assets/css/variables.scss";
.news-state {
  .news-box {
    width: 100%;
    overflow: hidden;
    .title {
      width: 100%;
      text-align: center;
      font-size: 40px;
      color: $color-primary;
      font-family: TimesNewRoman;
      font-style: italic;
      font-weight: lighter;
      margin-top: 90px;
      span {
        font-size: 42px;
        font-weight: 600;
        color: $color-primary;
        font-style: italic;
      }
    }
    .news-ul {
      float: left;
    }
    .smallTitle {
      width: 100%;
      text-align: center;
      margin: 60px auto;
      span {
        display: inline-block;
        height: 30px;
        line-height: 30px;
        text-align: center;
        padding: 0 20px;
        background: $color-primary;
        font-size: 20px;
        font-family: TimesNewRoman;
        color: rgba(255, 255, 255, 1);
        cursor: pointer;
      }
    }
    .pagination-box {
      margin: 76px 0;
    }
  }
  .news-box2 {
    background: url("../../assets/image/news_bg1.png") no-repeat;
    background-size: 100% 100%;
  }
  .bg2 {
    width: 100%;
    position: relative;
    img {
      display: block;
      width: 100%;
      z-index: 1;
    }
    .bg2-con {
      position: absolute;
      top: 50%;
      left: 0;
      width: 100%;
      height: 170px;
      margin-top: -50px;
      z-index: 10;
      p {
        width: 100%;
        text-align: center;
        color: #ffffff;
      }
      .p1 {
        font-size: 72px;
        font-family: TimesNewRoman;
        font-weight: 700;
        height: 130px;
        position: relative;
      }
      .p1::after {
        content: "";
        width: 64px;
        height: 4px;
        background: rgba(255, 255, 255, 1);
        position: absolute;
        left: 50%;
        margin-left: -32px;
        bottom: 30px;
      }
      .p2 {
        font-size: 36px;
        font-family: SourceHanSansSC-Normal;
      }
    }
  }
}
@media (max-width: 768px) {
  .news-state {
    .bg2 {
      img {
        height: 180px;
      }
      .bg2-con {
        margin: 0;
        height: 145px;
        top: 0;
        box-sizing: border-box;
        padding-top: 74px;
        .p1 {
          font-size: 25px;
          font-family: TimesNewRomanPS-BoldMT;
          font-weight: bold;
          color: rgba(255, 255, 255, 1);
          line-height: 28px;
          height: 28px;
        }
        .p1::after {
          content: "";
          width: 22px;
          height: 2px;
          background: rgba(255, 255, 255, 1);
          position: absolute;
          left: 50%;
          margin-left: -13px;
          bottom: -10px;
        }
        .p2 {
          margin-top: 27px;
          font-size: 12px;
          font-family: SourceHanSansSC-Normal;
          font-weight: 400;
        }
      }
    }
    .news-box {
      .content-mobile {
        width: 100%;
        text-align: center;
        .title {
          width: 100%;
          padding-left: 23%;
          box-sizing: border-box;
          text-align: left;
          font-size: 25px;
          font-weight: normal;
          color: rgba(0, 52, 120, 1);
          font-family: TimesNewRomanPS-BoldItalicMT;
          margin-top: 30px;
          display: inline-block;
          margin-bottom: 9px;
        }
        .smallTitle-right {
          font-size: 21px;
          font-family: TimesNewRomanPS-ItalicMT;
          font-weight: normal;
          color: rgba(0, 52, 120, 1);
          line-height: 20px;
          padding-left: 29%;
        }
      }
      .smallTitle {
        margin: 25px 0 15px;
        span {
          display: inline-block;
          height: 27px;
          text-align: center;
          padding: 0 12px;
          background: $color-primary;
          font-size: 14px;
          font-family: PingFangSC-Regular;
          font-weight: 400;
          color: rgba(255, 255, 255, 1);
          line-height: 27px;
        }
      }
      .news-ul {
        margin-bottom: 0;
      }
    }
  }
}
@media screen and (min-width: 415px) and (max-width: 768px) {
  .news-state {
    .news-box {
      .content-mobile {
        width: 100%;
        text-align: center;
        .title {
          width: auto;
          display: inline-block;
          padding-left: 0;
          margin-left: -10%;
        }
        .smallTitle-right {
          padding-left: 15%;
        }
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/pages/appointment/stateOfnews.vue